/* Generated file. Do not modify. Please check more details in build/generate.ts */
import * as React from "react";
import type { IconProps } from "../IconTypes";
import { IconWrapper } from "../IconWrapper";
export function GemIcon(props: IconProps) {
    return (<IconWrapper {...props}>
            {<path d="m14.535 8.947 5.496 5.71 5.434-5.71zm13.428 1.72-4.497 4.666h8.057zm3.123 7.614H8.914l11.117 12.096zm-22.61-2.948h8.058l-4.497-4.666zm27.107 2.518-14.49 15.72c-.25.306-.687.429-1.062.429-.437 0-.874-.123-1.124-.43L4.417 17.85c-.5-.552-.562-1.35-.125-1.903l6.995-9.333c.313-.368.75-.614 1.25-.614h14.989c.437 0 .874.246 1.187.614l6.995 9.333c.437.553.374 1.351-.125 1.904"/>}
        </IconWrapper>);
}
